function Home({ user, onLogout }) {
  return (
    <div className="home-container">
      <nav className="home-nav">
        <div className="brand-logo" style={{ fontSize: 22 }}>
          bluprint
        </div>
        <div className="home-nav-links">
          <a href="#home">Home</a>
          <a href="#about">About Us</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact Us</a>
          <a href="#app">Download App</a>
          <button className="logout-btn" onClick={onLogout}>
            Log out
          </button>
        </div>
      </nav>

      <section className="hero" id="home">
        <div className="hero-eyebrow">AI Relationship Intelligence</div>
        <h1>
          See yourself clearly.
          <br />
          See others honestly.
        </h1>
        <p>
          Move through every relationship with intelligence. Bluprint helps you understand what is
          really happening between you and the people in your life — so you can move with more
          clarity, confidence, and self-awareness.
        </p>
        <div className="hero-cta">
          <button className="btn-primary" style={{ width: 'auto', padding: '13px 28px' }}>
            Get Your Bluprint →
          </button>
          <button className="btn-secondary" style={{ width: 'auto', padding: '13px 28px' }}>
            Start via iMessage
          </button>
        </div>
        <div className="hero-note">
          Free to start · Available through iMessage, WhatsApp, and the app
        </div>
        <div className="pill-row">
          <div className="pill">Decode yourself</div>
          <div className="pill">Understand them</div>
          <div className="pill">Navigate the dynamic</div>
          <div className="pill">Build better relationships</div>
        </div>
        {user && (
          <div style={{ marginTop: 32, color: '#9ca3af', fontSize: 13 }}>
            Signed in as{' '}
            <span style={{ color: '#a78bfa' }}>
              {user.identifier || user.email || user.phone || user.name}
            </span>
          </div>
        )}
      </section>

      <section className="section" id="services">
        <div className="hero-eyebrow" style={{ textAlign: 'center' }}>
          How It Works
        </div>
        <h2 className="section-title">Your personal relationship agent.</h2>
        <p className="section-subtitle">
          Bluprint starts as an agent that gets to know you — through iMessage, WhatsApp, or the app
          — then helps you understand yourself, read other people more clearly, and know how to
          move.
        </p>

        <div className="steps-grid">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3>Meet your agent</h3>
            <p>
              Start through iMessage, WhatsApp, or the app. No friction — just a relationship agent
              that gets to know you.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <h3>Get your Bluprint</h3>
            <p>
              Answer a few questions and your agent builds a deep read on how you relate, what you
              need, and what shapes your patterns.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <h3>Bump phones</h3>
            <p>Tap phones to instantly reveal how you click, where you differ, and what to know.</p>
          </div>
          <div className="step-card">
            <div className="step-number">4</div>
            <h3>Dynamic Insights</h3>
            <p>
              Ask about a relationship, a text, a conflict, or yourself — and get guidance in real
              time.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">5</div>
            <h3>Run Bonds</h3>
            <p>
              See how you and someone else fit, across attraction, communication, values, and more.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">6</div>
            <h3>Run Simulations</h3>
            <p>Preview how a dynamic could play out before you're in it.</p>
          </div>
          <div className="step-card">
            <div className="step-number">7</div>
            <h3>Organize your relationships</h3>
            <p>
              Keep track of the people in your life — romantic, friends, work, and family — all in
              one place.
            </p>
          </div>
        </div>
      </section>

      <footer className="footer" id="contact">
        <div className="brand-logo" style={{ fontSize: 20, marginBottom: 16 }}>
          bluprint
        </div>
        <div className="footer-links">
          <a href="#about">About Us</a>
          <a href="#contact">Contact Us</a>
          <a href="#services">Services</a>
          <a
            href="https://www.thebluprint.app/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.thebluprint.app/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms &amp; Conditions
          </a>
        </div>
        <address>
          BLUPRINT PLATFORM, INC.
          <br />
          540 S Orlando Ave, West Hollywood — 90048-4626
          <br />
          United States (US)
          <br />
          +1 144 857 051 · admin@thebluprint.app
        </address>
        <div>Copyright © 2026 Bluprint · Powered by Bluprint</div>
      </footer>
    </div>
  );
}

export default Home;
